import { render, staticRenderFns } from "./ModalSeats.vue?vue&type=template&id=6410f2d4&scoped=true&"
import script from "./ModalSeats.vue?vue&type=script&lang=js&"
export * from "./ModalSeats.vue?vue&type=script&lang=js&"
import style0 from "./ModalSeats.vue?vue&type=style&index=0&id=6410f2d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6410f2d4",
  null
  
)

export default component.exports